import { useQuery } from "@apollo/client";
import React from "react";
import { GET_POSTS } from "../../hooks/usePost";
import Post from "./Post";

const Posts = () => {
  const { loading, error, data } = useQuery(GET_POSTS);
  if (error)
    return (
      <p className=" text-center mt-5 text-6xl font-extrabold text-lime-500 ">{`${error.message}`}</p>
    );
  if (loading)
    return (
      <p className=" text-center mt-5 text-6xl font-extrabold text-lime-500 ">
        Loading...
      </p>
    );
  if (data)
    return (
      <div className="grid grid-cols-4 gap-4 mx-10 justify-around my-9 ">
        {data?.blog_posts.map((blogPost) => (
          <Post key={blogPost.id} blogPost={blogPost} />
        ))}
      </div>
    );
};

export default Posts;
